import React, { useState } from 'react';
import NavBar from '../NavBar';
import axios from 'axios';
import sendEmail from '../SendEmail';

function Login() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState("");
  const [buttonEnabled, setButtonEnabled] = useState(false);
  const [countdown, setCountdown] = useState();
  const [isLoggingIn, setIsLoggingIn] = useState(false); // New state for login button loading
  const [isVerifying, setIsVerifying] = useState(false); // New state for verify button loading
  const [isResending, setIsResending] = useState(false); // New state for resend button loading

  const [otp, setOtp] = useState('');
  const [verify, setVerify] = useState(false);
  const [passcode, setPasscode] = useState('');
  const [checkEmail, setCheckEmail] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'email') {
      const lowercaseEmail = value.toLowerCase();
      setEmail(lowercaseEmail);
    }
  };

  const verifyEmail = async (e) => {
    e.preventDefault();
    setMessage('');
    setIsLoggingIn(true); // Disable login button

    try {
      // Check if the email exists in the Laravel backend
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/check-email`, { email });

      if (response.status === 200) {
        setCheckEmail(true);
        console.log('Message:', response.data.message);
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        // console.log('Email not exist');
      } else {
        // console.log('An error occurred. Please try again.');
      }
    } finally {
      setIsLoggingIn(false); // Re-enable login button
    }
    enableResend();
    setVerify(true);
  }

  const enableResend = () => {
    setButtonEnabled(false);
    setCountdown(30); // Reset countdown timer

    const timer = setInterval(() => {
      setCountdown(prevCountdown => prevCountdown - 1);
    }, 1000); // Update countdown every second

    // // Enable the button after countdown finishes
    setTimeout(() => {
      clearInterval(timer);
      setButtonEnabled(true);
    }, 30000);
  };

  const resend = async () => {
    setIsResending(true); // Disable resend button
    enableResend(); // Start countdown and disable button
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/resend-otp`, {
        email: email,
      });

      setMessage(response.data.message);
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        setMessage(error.response.data.message || 'Something went wrong');
      } else if (error.request) {
        // The request was made but no response was received
        setMessage('No response from server. Please try again later.');
      } else {
        // Something happened in setting up the request that triggered an Error
        setMessage('Failed to resend OTP. Please try again later.');
      }
    } finally {
      setIsResending(false); // Ensure button is re-enabled even on error
    }
  }

  const verifyOTP = async (e) => {
    e.preventDefault();
    setIsVerifying(true); // Disable verify button

    try {
      // Send the data to the API
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/verify-otp`, {
        email,
        otp, // Send OTP to the server
      });

      setMessage(response.data.message);
      localStorage.setItem('userEmail', email);
      localStorage.setItem('token', response.data.token);
      window.location.reload();
    } catch (error) {
      // Handle error
      console.error('OTP verification failed:', error.response.data.message);
      setMessage(error.response.data.message)
    } finally {
      setIsVerifying(false); // Ensure button is re-enabled even on error
    }
  };

  return (
    <div>
      <NavBar />
      <div className="py-24 px-8">
        <div className="md:max-w-xl md:mx-auto bg-white p-4 md:p-8 md:rounded md:shadow-lg">
          {verify ? (
            <div className="max-w-lg mx-auto p-4">
              <h2 className="text-2xl font-semibold mb-4">Verify your email</h2>
              <p className="text-lg mb-4">If your email exist, you will receive OTP on your email {email}:</p>
              <button className="text-md text-black underline mb-4" onClick={() => setVerify(false)}>Change email? Click here!</button>
              <form onSubmit={verifyOTP}>
                <div className="mb-4">
                  <label className="block text-gray-700">OTP:</label>
                  <input
                    type="text"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    placeholder='XXXXXX'
                    className="w-full border rounded py-2 px-3 focus:outline-none focus:ring focus:border-blue-300"
                    required
                  />
                </div>
                <p className='mt-4 text-red-500 text-center'>{message}</p>
                <div className='flex space-x-2'>
                  <button
                    type="submit"
                    className="btn-primary py-2 px-4 rounded"
                    disabled={isVerifying} // Disable button while verifying
                  >
                    {isVerifying ? 'Verifying...' : 'Verify'}
                  </button>
                </div>
              </form>
              <button
                className={`${buttonEnabled && !isResending ? 'bg-green-400 hover:bg-green-500 focus:border-green-300' : 'bg-gray-400 hover:bg-gray-500 focus:border-gray-300'} mt-4 text-neutral-50 py-2 px-4 rounded focus:outline-none focus:ring`}
                onClick={resend} 
                disabled={!buttonEnabled || isResending} // Disable button while resending or countdown is active
              >
                {isResending ? 'Resending...' : (buttonEnabled ? 'Resend OTP' : `Resend OTP (${countdown})`)}
              </button>
            </div>
          ):(
            <div>
              <h1 className="text-3xl mb-6 text-center font-semibold">Login</h1>
    
              <div className="mb-12">
                <p className="text-lg text-center text-gray-700">
                  Enter your email to login
                </p>
              </div>
              <form onSubmit={verifyEmail}>
                <div className="mb-6">
                  <div className="mb-4">
                    <label htmlFor="email" className="block text-sm font-medium text-gray-600">
                      Email
                    </label>
                    <div className='flex'>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="mt-1 p-2 w-full border rounded-md"
                        placeholder="Enter your email"
                        required
                        value={email}  // Update to use the state variable
                        onChange={handleChange}  // Update to use the handleChange function
                      />
                    </div>
                  </div>
                  <p className='mt-4 text-black text-center'>{message}</p>
                  <button
                    className={`btn-primary px-4 py-2 rounded w-full`}
                    type="submit"
                    disabled={isLoggingIn} // Disable button while logging in
                  >
                    {isLoggingIn ? 'Logging in...' : 'Login'}
                  </button>
                </div>
              </form>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Login;
